import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from "react-tiny-popover";
import { Icon } from "@fluentui/react/lib/Icon";

import { TEXT } from "../../../../../shared/constants/texts";
import { VIEW_FOLDER_AND_DOCUMENTS, EMAIL_THREAD_FORMAT } from "../../../../../shared/constants/addToICIToggleView";
import { ICON } from "../../../../../shared/constants/icons";
import { setEmailThreadFormat, setViewFolderAndDocuments, setEmailAttachmentsIncluded } from "../../../redux/slice";

const HeaderAddToIci: React.FC = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: any) => state.addToIciSlice);
  const { selectedEmailThreadFormat, selectedViewFolderAndDocuments, areAttachmentsIncluded, isAdvancePageEnabled } =
    state;
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);

  let classNameForAttachmentFlag = "attachment-checkmark-hidden";
  if (areAttachmentsIncluded) {
    classNameForAttachmentFlag = "attachment-checkmark";
  }

  const onEnterPressSettings = (e) => {
    if (
      e.key === TEXT.ENTER ||
      e.keyCode === TEXT.ENTER_KEY_CODE ||
      e.key === TEXT.ESCAPE ||
      e.keyCode === TEXT.ESCAPE_KEY_CODE
    ) {
      onPopoverHandler();
    }
  };

  const onPopoverHandler = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const onEnterPressFormat = (e, format) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      onFormatChange(format);
    }
  };

  const onFormatChange = (format) => {
    dispatch(setEmailThreadFormat(format));
  };

  const onEnterPressView = (e, view) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      onViewChange(view);
    }
  };

  const onViewChange = (view) => {
    dispatch(setViewFolderAndDocuments(view));
  };

  const onEnterPressEmailAttachmentsIncluded = (e) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      onSetEmailAttachmentsIncluded();
    }
  };

  const onSetEmailAttachmentsIncluded = () => {
    dispatch(setEmailAttachmentsIncluded(!areAttachmentsIncluded));
  };

  return (
    <div className="header-container-add-to-ici">
      <p>{!isAdvancePageEnabled ? TEXT.DRAG_AND_DROP_EMAILS_TO_ADD_TO_ICI : TEXT.ADVANCE_PAGE_ADD_TO_ICI}</p>
      <div className="popover-container-header-add-to-ici">
        <Popover
          containerClassName="popover-header-add-to-ici"
          isOpen={isPopoverOpen}
          positions={["bottom"]}
          onClickOutside={() => setIsPopoverOpen(!isPopoverOpen)}
          content={
            <React.Fragment>
              <div className="toggle-group">
                <label className="label">{TEXT.VIEW}</label>
                {VIEW_FOLDER_AND_DOCUMENTS.map((view) => (
                  <p
                    className="views"
                    key={view.id}
                    onClick={() => onViewChange(view)}
                    tabIndex={1}
                    onKeyDown={(e) => onEnterPressView(e, view)}
                  >
                    <input
                      type={"radio"}
                      value={view.label}
                      id={`view + ${view.id}`}
                      name={"VIEW_FOLDER_AND_DOCUMENTS"}
                      checked={selectedViewFolderAndDocuments && selectedViewFolderAndDocuments.id === view.id}
                      onChange={() => {}}
                    ></input>
                    <label className="label-data" htmlFor={`view + ${view.id}`}>
                      {view.label}
                    </label>
                  </p>
                ))}
              </div>
              <div className="toggle-group">
                <label className="label">{TEXT.UPLOADED_EMAIL_FILE_FORMAT}</label>
                {EMAIL_THREAD_FORMAT.map((format) => (
                  <p
                    className="formats"
                    key={format.id}
                    onClick={() => onFormatChange(format)}
                    tabIndex={1}
                    onKeyDown={(e) => onEnterPressFormat(e, format)}
                  >
                    <input
                      type={"radio"}
                      value={format.label}
                      id={`format + ${format.id}`}
                      name={"EMAIL_THREAD_FORMAT"}
                      checked={selectedEmailThreadFormat && selectedEmailThreadFormat.id === format.id}
                      onChange={() => {}}
                    ></input>
                    <label className="label-data" htmlFor={`format + ${format.id}`}>
                      {format.label}
                    </label>
                  </p>
                ))}
              </div>
              <div className="toggle-group">
                <label className="label">{TEXT.ATTACHMENT_OPTIONS}</label>
                <p
                  className="attachment-options"
                  onClick={onSetEmailAttachmentsIncluded}
                  tabIndex={1}
                  onKeyDown={onEnterPressEmailAttachmentsIncluded}
                >
                  <span className={classNameForAttachmentFlag}>&#x2713; </span>
                  <label className="label-data">{TEXT.ADD_ATTACHMENTS_FROM_EMAILS}</label>
                </p>
              </div>
            </React.Fragment>
          }
        >
          <div
            className="settings-menu"
            tabIndex={1}
            onClick={onPopoverHandler}
            onKeyDown={onEnterPressSettings}
            title={TEXT.SETTINGS}
          >
            <span className="icon">
              <Icon iconName={ICON.SETTINGS} />
              <span className="sr-only">{TEXT.SETTINGS}</span>
            </span>
          </div>
        </Popover>
      </div>
    </div>
  );
};

export default HeaderAddToIci;
